import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const ScrollButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(4),
  right: theme.spacing(4),
  backgroundColor: '#0f3b5e',
  color: 'white',
  border: '2px solid white',
  '&:hover': {
    backgroundColor: '#154b6e',
  },
  zIndex: 999,
}));

export default function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={show}>
      <ScrollButton onClick={scrollToTop} size="medium">
        <KeyboardArrowUp />
      </ScrollButton>
    </Zoom>
  );
}